<template>
  <div>
    <compWrapper title="仓库发运方式映射"
                 theme="primary">
      <compFormQuery v-if="type=='query'"
                     :formdata="getWarehouse"
                     :value="formData"
                     :labelWidth="235"></compFormQuery>
      <compFormEdit v-else
                    ref="relation"
                    class="margin-top-15 clearfix"
                    :formdata="getWarehouse"
                    v-model="formData"
                    :labelWidth="235" />
    </compWrapper>
    <div v-if="!query"
         class="text-right"
         v-show="type!='query'">
      <Button type="primary"
              class="width-15per"
              @click="submit">提交</Button>
      <Button class="width-15per margin-left-10"
              @click="cancel">取消</Button>
    </div>
    <compWrapper title="操作历史"
                 theme="gray"
                 v-if="query">
      <compLog class="margin-15"
               :data="opLogList"></compLog>
    </compWrapper>
    <Spin size="large"
          fix
          v-if="loading"></Spin>
  </div>
</template>
<script>

import { HttpQuerySysWarehouse, HttpSaveSysWarehouse, HttpAllLogs } from "@/service/managechannel/managechannel";
// import { mapState, mapGetters } from "vuex";

export default {
  props: ['activeids', 'querytype'],
  components: {
    // compWrapper: () => import("@components/templates/wrapper"),
    // compFormQuery: () => import("@components/templates/formquery"),
    // compFormEdit: () => import("@components/templates/formedit"),
    compLog: () => import("./log"),
  },
  data () {
    return {
      loading: false,
      type: this.$route.params.type || this.querytype,
      id: this.$route.query.id || this.activeids,
      query: false,
      opLogList: [],
      formData: {
        // remark:'',
      }
    }
  },
  created () {
    // console.log(this.$route.params.type)
    this.query = this.type === "query";
    if (this.type == 'edit' || this.type == 'query') {
      this.getDetail()
    }
  },
  computed: {
    getWarehouse () {
      let showquery = this.type == 'edit' || this.type == 'query'
      return [
        {
          label: "系统发运方式",
          key: "carrierServiceCode",
          span: 24,
          required: false,
          query: showquery,
          formItem: {
            style: "width:50%"
          },
          valueText: `${this.formData.carrierServiceCode}(${this.formData.carrierCode} ${this.formData.carrierServiceName})`
        },
        {
          label: "对应仓库",
          span: 24,
          key: "warehouseCode",
          required: false,
          query: showquery,
          formItem: {
            style: "width:50%"
          },
          valueText: `${this.formData.warehouseCode}(${this.formData.warehouseTitle})`
        },
        {
          label: "仓库Shipping Method Code",
          key: "carrierServiceApiCode",
          span: 24,
          query: this.type == "query",
          formItem: {
            style: "width:50%"
          },
        },
        {
          label: "备注",
          tag: 'vTextarea',
          span: 24,
          key: "memo",
          show: this.type == 'query',
          query: this.type == 'query',
          required: false,
          formItem: {
            style: "width:50%"
          },
        },
        {
          label: "备注",
          tag: 'vTextarea',
          span: 24,
          key: "remark",
          show: this.type == 'edit',
          required: false,
          formItem: {
            style: "width:50%"
          },
        },
      ];
    },
  },
  methods: {
    async getDetail () {
      // if (this.type === 'add') return;
      this.loading = true;
      HttpQuerySysWarehouse({
        id: this.id
      }).then(res => {
        this.handleResponse(res.data);
        this.loading = false;
      }, err => {
        this.loading = false;
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
      });
      // 请求日志的接口
      HttpAllLogs({
        search: {
          EQ_opDataId: this.id,
          EQ_opModel: 'WarehouseCarrierService'
        }
      }).then(res => {
        this.opLogList = res.data
      }, err => {

      })
    },
    handleResponse (data = {}) {
      this.formData = data
      // console.log(this.formData)
      this.formData.carrierServiceCode = data.carrierServiceCode
      this.formData.carrierServiceApiCode = data.carrierServiceApiCode
      // this.opLogList = data.orderLogs
      // console.log(data)
      this.formData.remark = data.memo
    },
    async submit () {
      const valid = await this.$refs['relation'].validate();
      if (!valid) return;
      this.loading = true
      HttpSaveSysWarehouse({
        id: this.id,
        ...this.formData
      }).then(res => {
        this.$Message.success(res.message);
        this.$router.push({
          name: 'sysmanageware',
        });
      }).finally(() => {
        this.loading = false
      })
    },
    cancel () {
      this.$router.push({ name: "sysmanageware" })
    }
  },
}
</script>
